import React, { useEffect } from 'react';
import './App.css';

function App() {
  useEffect(() => {
    // Scroll reveal logic
    const reveals = document.querySelectorAll('.reveal');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    reveals.forEach(el => observer.observe(el));

    return () => {
      reveals.forEach(el => observer.unobserve(el));
    };
  }, []);

  return (
    <div className="App">
      {/* NAV */}
      <nav>
        <div className="nav-brand">A Travessia</div>
        <div className="nav-links">
          <a href="#sinopse">Sinopse</a>
          <a href="#filme">Filme</a>
          {/* <a href="#making-of">Making Of</a>
          <a href="#bastidores">Bastidores</a> */}
        </div>
      </nav>

      {/* HERO */}
      <section className="hero">
        <div className="hero-arc"></div>
        <div className="hero-arc"></div>
        <div className="hero-arc"></div>

        <p className="hero-label">Curta-Metragem · Drama · 2min</p>
        <h1 className="hero-title">
          A Travessia
          <span>Um filme de Guinga.Space</span>
        </h1>
        <p className="hero-subtitle">A jornada de uma mãe. Uma perda que não tem palavras.</p>

        <div className="scroll-hint">
          <div className="scroll-line"></div>
          <span>Descer</span>
        </div>
      </section>

      {/* SINOPSE */}
      <section id="sinopse">
        <div className="container synopsis-container">
          <div className="synopsis-poster reveal">
            <img src="/images/poster_completo_atravessia.jpeg" alt="Poster A Travessia" />
          </div>
          <div className="synopsis-content">
            <p className="section-eyebrow reveal">— Sinopse</p>
            <div className="divider reveal"></div>
            <h2 className="section-title reveal">Uma dor que atravessa o silêncio</h2>
            <p className="synopsis-text reveal">
              Em <em>A Travessia</em>, acompanhamos uma mãe diante do inimaginável —
              a ausência irreversível de sua filha. Através de gestos mínimos e silêncios
              carregados, o filme explora o luto não como fim, mas como uma passagem:
              dolorosa, necessária, humana.<br /><br />
              Uma história sobre o amor que permanece mesmo quando tudo mais se vai.
            </p>
          </div>
        </div>
      </section>

      {/* FILME */}
      <section id="filme">
        <div className="container">
          <div className="video-label reveal">
            <div className="video-label-line"></div>
            <span className="video-label-text">Assista ao curta</span>
            <div className="video-label-line"></div>
          </div>
          <div className="video-wrapper reveal">
            {/* ✏️ SUBSTITUA o ID do YouTube abaixo pelo ID real do seu vídeo */}
            <iframe
              src="https://www.youtube.com/embed/q8xYhxD0LeI?rel=0&color=white&modestbranding=1"
              title="A Travessia — Curta-Metragem"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen>
            </iframe>
          </div>
          <p className="video-caption reveal">A Travessia · 2025 · 2 min</p>
        </div>
      </section>

      {/* MAKING OF
      <section id="making-of">
        <div className="container">
          <p className="section-eyebrow reveal">— Nos bastidores</p>
          <div className="divider reveal"></div>
          <div className="making-grid">
            <div>
              <h2 className="section-title reveal">O making of</h2>
              <div className="making-text reveal">
                <p>Por trás de cada frame de <em>A Travessia</em> existe um trabalho
                silencioso de construção emocional — de atriz, equipe e direção —
                buscando a verdade de cada cena.</p>
                <p>Neste making of você acompanha como o curta foi concebido, filmado
                e sentido por todos os envolvidos.</p>
              </div>
            </div>
            <div>
              <div className="video-wrapper reveal">
                <iframe
                  src="https://www.youtube.com/embed/SEU_MAKING_OF_ID_AQUI?rel=0&color=white&modestbranding=1"
                  title="Making Of — A Travessia"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen>
                </iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
      */}

      {/* BASTIDORES
      <section id="bastidores">
        <div className="container">
          <p className="section-eyebrow reveal">— Galeria</p>
          <div className="divider reveal"></div>
          <h2 className="section-title reveal">Fotos dos bastidores</h2>
          <div className="bts-grid">
            <div className="bts-item reveal">
              <div className="bts-placeholder">Foto 1 — Cena principal</div>
            </div>
            <div className="bts-item reveal">
              <div className="bts-placeholder">Foto 2</div>
            </div>
            <div className="bts-item reveal">
              <div className="bts-placeholder">Foto 3</div>
            </div>
            <div className="bts-item reveal">
              <div className="bts-placeholder">Foto 4</div>
            </div>
            <div className="bts-item reveal">
              <div className="bts-placeholder">Foto 5</div>
            </div>
          </div>
          <p className="bts-note reveal">Adicione as fotos substituindo os placeholders no código HTML</p>
        </div>
      </section>
      */}

      {/* FOOTER */}
      <footer>
        <p className="footer-title">A Travessia</p>
        <p className="footer-sub">© 2025 · Todos os direitos reservados</p>
      </footer>
    </div>
  );
}

export default App;
